import { BehaviorSubject } from "rxjs";
import Axios from "axios";

import CryptoJS from "crypto-js";
import _ from "lodash";

var secretKey = "HereIsTheMySecretKey_LOL";

const currentUserSubject = new BehaviorSubject(
  // console.log('localStorage.getItem("USINFO") ', localStorage.getItem("USINFO"))
  // localStorage.getItem("USINFO") ? JSON.parse(localStorage.getItem("USINFO")) : {}
  get("USINFO")
);

export const authenticationService = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
  set,
  get
};
function set(key, value) {
  if (key && value && String(key).length > 0 && String(value).length > 0) {
    let setEncryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
    window.localStorage.setItem(key, setEncryptedData);
  } else {
    console.error('key value is undefined');
  }
}

function get(key) {
  let getEncryptedData = window.localStorage.getItem(key);
  if (!_.isNull(getEncryptedData))
    return JSON.parse(CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(CryptoJS.enc.Utf8))
  return null;
}

function login(username, password) {
  // Call API
  // return Axios;
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("USINFO");
  currentUserSubject.next(null);
}



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js